/* STATUS / AGENT NOTES (2026-09-07)
 * Agent START: Codex viewport-gated review posters; playback remains owned by each review component.
 */
(() => {
  if (window.ScoochReviewPosters) {
    window.ScoochReviewPosters.init(document);
    return;
  }
  const seen = new WeakSet();
  const load = video => {
    if (!video.poster && video.dataset.scoochReviewPoster) video.poster = video.dataset.scoochReviewPoster;
    observer?.unobserve(video);
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) load(entry.target); });
  }, { rootMargin: '600px 200px', threshold: 0 }) : null;
  function init(root) {
    root.querySelectorAll('video[data-scooch-review-poster]').forEach(video => {
      if (seen.has(video)) return;
      seen.add(video);
      if (observer) observer.observe(video);
      else load(video);
    });
  }
  window.ScoochReviewPosters = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
/* Agent END: Codex review posters. */
